<div class="no-truncate d-flex">
  <mat-checkbox
    [attr.data-testId]="'set-row' + context.row.index + '-' + context.column.columnDef + '-state'"
    [(ngModel)]="context.data[context.column.columnDef]"
    (change)="context.cell.actions.onEdited()"
    [disabled]="!context.cell.allowEditing"
  ></mat-checkbox>
</div>
